const TEMP_RIMAGO_MP_HOST = 'rimagomp.seequent.com';

export const getIsProduction = () => {
    const { host } = window.location;
    const productionHosts = ['imagomp.seequent.com', TEMP_RIMAGO_MP_HOST];

    return productionHosts.includes(host);
};
